"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uuid = require("uuid");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = require("./Checkbox.styles");

var _images = require("../../assets/images");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Checkbox = ({
  label,
  name,
  value,
  onChange,
  disabled,
  className,
  checked,
  isPartial,
  otherProps,
  ...restProps
}) => {
  const [selected, setSelected] = (0, _react.useState)(false);
  const checkboxRef = (0, _react.useRef)((0, _uuid.v4)());
  (0, _react.useEffect)(() => {
    setSelected(checked);
  }, [checked]);

  const handleCheck = e => {
    setSelected(e.target.checked);
    onChange(e);
  };

  return /*#__PURE__*/_react.default.createElement(_Checkbox.StyledCheckboxWrapper, {
    disabled: disabled,
    className: className,
    tabIndex: 0
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.StyledBox, {
    selected: selected
  }, isPartial ? /*#__PURE__*/_react.default.createElement(_images.Partial, {
    opacity: "0"
  }) : /*#__PURE__*/_react.default.createElement(_images.Checkmark, {
    opacity: "0"
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    className: "checkbox-input",
    type: "checkbox",
    name: name || checkboxRef.current,
    onChange: handleCheck,
    value: value,
    checked: selected
  }, restProps, otherProps)), /*#__PURE__*/_react.default.createElement(_Checkbox.StyledText, null, label));
};

exports.Checkbox = Checkbox;
Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  className: '',
  onChange: () => {},
  label: '',
  isPartial: false
};
Checkbox.propTypes = {
  /** Label for Checkbox*/
  label: _propTypes.default.string.isRequired,

  /** Value will be returned onChange event */
  value: _propTypes.default.string.isRequired,

  /** OnChange callback with entire event  */
  onChange: _propTypes.default.func.isRequired,

  /** A name for checkbox */
  name: _propTypes.default.string,

  /**Boolean value for checked state */
  checked: _propTypes.default.bool,

  /** Boolean value for Disabled state */
  disabled: _propTypes.default.bool,

  /** Boolean value for Partial state, to get partial state, we should pass checked=true and isPartial=true  */
  isPartial: _propTypes.default.bool,

  /** CSS class name */
  className: _propTypes.default.string,

  /** otherProps, is used to pass additional props which can accept input with checkbox, like onKeyDown, 	onMouseEnter, data-testid */
  otherProps: _propTypes.default.object
};